import { ImageProps, MediaType } from '../types';

export const buildStaticImage = ({ name }: { name?: string }) =>
  `https://traegergrills.a.bigcontent.io/v1/static/${name}`;

export const buildImageSrc = (
  assetObj?: ImageProps | MediaType | null,
  width?: string | number,
  aspectWidth?: number | null,
  aspectHeight?: number | null,
  url?: string | null,
  quality?: number,
): string => {
  const imageObj = assetObj as ImageProps;
  const mediaObj = assetObj as MediaType;

  if (imageObj?.static && imageObj?.image) {
    return `https://traegergrills.a.bigcontent.io/v1/static/${imageObj.image.name}`;
  }
  if (imageObj?.image) {
    return buildImageSrc(imageObj.image, width, aspectWidth, aspectHeight, null, quality);
  }
  const searchParams = new URLSearchParams({
    scaleFit: 'poi&$poi2$',
    fmt: 'auto',
  });

  if (width) {
    searchParams.append('w', String(width));
  }
  if (aspectWidth && aspectHeight) {
    searchParams.append('sm', 'aspect');
    searchParams.append('aspect', `${aspectWidth}:${aspectHeight}`);
  }
  searchParams.append('qlt', 'default');

  if (mediaObj) {
    // NOTE: While developing and making edits, add '&v=99' to the end of the url to view
    // the non-cached version of the image.
    return `https://i8.amplience.net/i/${mediaObj.endpoint}/${mediaObj.name}?${searchParams}`;
  }
  if (url) {
    const searchIndex = url.indexOf('?');
    return `${searchIndex === -1 ? url : url.substring(0, searchIndex)}?${searchParams}`;
  }
  return `https://i8.amplience.net/i/traeger/image-placeholder-icon-new?${searchParams}`;
};

export default buildImageSrc;
